const isRoleIncluded = (role, options) => {
    var _a, _b;
    if ('only' in options)
        return (_a = options.only) === null || _a === void 0 ? void 0 : _a.includes(role);
    if ('exclude' in options)
        return !((_b = options.exclude) === null || _b === void 0 ? void 0 : _b.includes(role));
    return true;
};

export { isRoleIncluded };
